import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperOptions } from 'swiper';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-carte',
  templateUrl: './carte.component.html',
  styleUrls: ['./carte.component.scss']
})
export class CarteComponent implements OnInit {

  id:string ;

  constructor(public dialog: MatDialog, private activatedRoute: ActivatedRoute, public router: Router, protected $gaService: GoogleAnalyticsService) {}

  ngOnInit(): void {
    if (localStorage.getItem('showModal') === 'true') {
      //this.openDialog();
    }
    localStorage.setItem('showModal', 'false');

    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.$gaService.pageView('/carte/' + this.id, 'Carte');
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
      width: '350px',
      data: { name: '' },
      panelClass: 'dialogation'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: false },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30,
    autoHeight: true
  };
}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog.html'
})
export class DialogOverviewExampleDialog {
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
}
